import { SvgIcon as MuiSvgIcon } from "@material-ui/core";
import { ComponentProps } from "react";
import { Color } from "../../theme/color";

export function MailIcon(props: ComponentProps<typeof MuiSvgIcon>) {
  return (
    <MuiSvgIcon viewBox="0 0 21 21" htmlColor={Color.Body} {...props}>
      <path d="M4.016 16.975q-.63 0-1.069-.437a1.45 1.45 0 0 1-.437-1.07V5.983q0-.632.437-1.07a1.45 1.45 0 0 1 1.07-.437h12.82q.63 0 1.069.438.437.437.437 1.069v9.487q0 .63-.437 1.069a1.46 1.46 0 0 1-1.07.437zm6.41-5.923q.105 0 .207-.031a1 1 0 0 0 .199-.086l5.96-3.816a.5.5 0 0 0 .202-.228.53.53 0 0 0 .035-.296.49.49 0 0 0-.282-.428.51.51 0 0 0-.537.025l-5.784 3.7-5.783-3.7a.51.51 0 0 0-.533-.027.5.5 0 0 0-.286.422.6.6 0 0 0 .035.313q.06.144.202.22l5.96 3.815q.096.054.199.086a.7.7 0 0 0 .206.031" />
    </MuiSvgIcon>
  );
}
export default MailIcon;
